// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Minimal Component CSS */
.minimalRoot {
  height: 100% !important;
}
.childrenContent {
  height: 90% !important;
}
/* Topbar Component CSS */
/* .topAppbar {
  box-shadow: none !important;
} */
.topAppbar {
  box-shadow: none !important;
  width: "100%";
}
.topToolbar {
  min-height: 50px !important;
  background-color: #670b4e !important;
}
.flexGrow {
  flex-grow: 1 !important;
}
.topbarheading {
  font-size: 18px !important;
  color: #ffffff !important;
}
.topbarButton {
  text-transform: none !important;
}
.topbarMenu {
  margin-top: 25px !important;
}
.arrowBackIcon {
  color: #ffffff !important;
  font-size: 18px !important;
  z-index: 99 !important;
  float: right !important;
}
.arrowBackIcon:hover {
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24),
    0 17px 50px 0 rgba(0, 0, 0, 0.19);
}
.sidebar-back-arrow {
  color: #ffffff !important;
  font-size: 26px !important;
  z-index: 99 !important;
  float: right !important;
  margin-bottom: 10px !important;
}
.sidebar-back-arrow:hover {
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24),
    0 17px 50px 0 rgba(0, 0, 0, 0.19);
  margin-bottom: 10px !important;
}
.icons {
  color: #ffffff !important;
}
.mainTopbarHeading {
  font-size: 18px !important;
  color: #ffffff !important;
}
.companylogo {
  height: 50px !important;
  /* margin-top: 4px; */
  /* width:5% !important */
}
.footerRoot {
  padding: 0% !important;
}
.menuIconTopbar {
  color: #670b4e !important;
  margin-right: 2% !important;
}
.test {
  min-width: 200px !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/layout.css"],"names":[],"mappings":"AAEA,0BAA0B;AAC1B;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA,yBAAyB;AACzB;;GAEG;AACH;EACE,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE;qCACmC;AACrC;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE;qCACmC;EACnC,8BAA8B;AAChC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B","sourcesContent":["@import \"global.css\";\n\n/* Minimal Component CSS */\n.minimalRoot {\n  height: 100% !important;\n}\n.childrenContent {\n  height: 90% !important;\n}\n/* Topbar Component CSS */\n/* .topAppbar {\n  box-shadow: none !important;\n} */\n.topAppbar {\n  box-shadow: none !important;\n  width: \"100%\";\n}\n.topToolbar {\n  min-height: 50px !important;\n  background-color: #670b4e !important;\n}\n.flexGrow {\n  flex-grow: 1 !important;\n}\n.topbarheading {\n  font-size: 18px !important;\n  color: #ffffff !important;\n}\n.topbarButton {\n  text-transform: none !important;\n}\n.topbarMenu {\n  margin-top: 25px !important;\n}\n.arrowBackIcon {\n  color: #ffffff !important;\n  font-size: 18px !important;\n  z-index: 99 !important;\n  float: right !important;\n}\n.arrowBackIcon:hover {\n  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24),\n    0 17px 50px 0 rgba(0, 0, 0, 0.19);\n}\n.sidebar-back-arrow {\n  color: #ffffff !important;\n  font-size: 26px !important;\n  z-index: 99 !important;\n  float: right !important;\n  margin-bottom: 10px !important;\n}\n.sidebar-back-arrow:hover {\n  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24),\n    0 17px 50px 0 rgba(0, 0, 0, 0.19);\n  margin-bottom: 10px !important;\n}\n.icons {\n  color: #ffffff !important;\n}\n.mainTopbarHeading {\n  font-size: 18px !important;\n  color: #ffffff !important;\n}\n.companylogo {\n  height: 50px !important;\n  /* margin-top: 4px; */\n  /* width:5% !important */\n}\n.footerRoot {\n  padding: 0% !important;\n}\n.menuIconTopbar {\n  color: #670b4e !important;\n  margin-right: 2% !important;\n}\n.test {\n  min-width: 200px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
